import { UAParser } from "ua-parser-js";

const parser = new UAParser(navigator.userAgent);

const isAndroid = () => /Android/i.test(navigator.userAgent);
const isMobileDevice = () => /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
const isFullscreenSupported = () => parser.getOS().name.toLowerCase() !== "ios";
const getBrowserName = () => parser.getBrowser().name.toLowerCase();
const isSafari = () => getBrowserName().indexOf("safari") !== -1 || getBrowserName() === "ios";
const isIE = () => getBrowserName() === "ie";
const isFirefox = () => getBrowserName() === "firefox";
const isChrome = () => getBrowserName() === "chrome" || getBrowserName() === "crios";
const isDashSupported = () => !isSafari();
const getBrowserMajorVersion = () => Number(parser.getBrowser().version.split(".")[0]);
const getOS = () => parser.getOS().version;
const isIOS = () => parser.getOS().name.toLowerCase() === "ios";

export const BrowserFeatureDetector = {
  getBrowserName,
  getBrowserMajorVersion,
  getOS,
  isMobileDevice,
  isFullscreenSupported,
  isIE,
  isFirefox,
  isChrome,
  isSafari,
  isAndroid,
  isDashSupported,
  isIOS,
};
